export type ColorSchemeMode = 'light' | 'dark' | 'system' | null | undefined;
export type ResolvedColorSchemeMode = 'light' | 'dark' | null | undefined;

export const isDarkColorScheme = (mode: ColorSchemeMode, systemMode?: ResolvedColorSchemeMode): boolean => {
  const resolvedMode = mode === 'system' ? systemMode : mode;
  return resolvedMode === 'dark';
};
